import React from 'react'
import UseHTML from '../../../components/hook/UseHTML';

const SponsorshipContact = props => {
    const { headers, contents } = props;
    return (
        <article className='sponsorship_contact'>
            <div>
                <h2>{headers[2]}</h2>
                <UseHTML html={contents[2]} />
            </div>
        </article>
    )
}

export default SponsorshipContact
